import React from 'react'
import Accordions from '../../../components/Accordions'


const Sem2Aiml1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1umfaIIrzUcuPPtvaz6ndkbixCu4Saerc/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1X7FxSS99usP07BA4yzialVP4MCo5kLgV/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://www.sonatech.ac.in/academics/syllabus/B.E-B.Tech/2025-Batch/CSE(AIML)-1-2-Sem-Curriculum-%20Syllabus.pdf",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">AIML Sem - 2</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem2Aiml1